import CryptoJS from 'crypto-js';

export class AESUtils {
    private static keyStr = "CnksgiSln2aQlhpL";
    private static _IV = "0000000000000000";

    // MD5加密
    public static md5Encrypt(str: string): string {
        return CryptoJS.MD5(str).toString();
    }

    // SHA256加密
    public static sha256Encrypt(str: string): string {
        return CryptoJS.SHA256(str).toString();
    }

    // Base64编码
    public static encodeBase64(data: string): string {
        return btoa(unescape(encodeURIComponent(data)));
    }

    // Base64解码
    public static decodeBase64(data: string): string {
        return escape(decodeURIComponent(atob(data)));
    }

    // AES CBC加密（对应原Dart代码中的aesCbcEncrypt） "E74DCC4E308FF61A94FC11DCF2B46588"
    public static aesEncrypt(plainText: string): string {
        const key = CryptoJS.enc.Utf8.parse(AESUtils.keyStr);
        const iv = CryptoJS.enc.Utf8.parse(AESUtils._IV);

        // 使用AES的CBC模式和PKCS7填充
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        return encrypted.toString();
    }

    // AES解密
    public static aesDecrypt(encrypted: string): string {
        const key = CryptoJS.enc.Utf8.parse(AESUtils.keyStr);
        const iv = CryptoJS.enc.Utf8.parse(AESUtils._IV);

        // 使用AES的CBC模式和PKCS7填充
        const decrypted = CryptoJS.AES.decrypt(
            encrypted,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    // 原Dart代码中的aesCbcEncrypt方法对应的实现（可选）
    public static aesCbcEncrypt(plainText: string): string {
        const key = CryptoJS.enc.Utf8.parse(AESUtils.keyStr);
        const iv = CryptoJS.enc.Utf8.parse(AESUtils._IV);

        // 使用AES的CBC模式和PKCS7填充
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        return encrypted.toString();
    }

    // 传递要传输的数据进来，加密后返回
    public static encryptData(param: string): { data: string, sign: string } {
        const ase256 = AESUtils.aesEncrypt(param);
        const sha256Str = AESUtils.sha256Encrypt(param)
        const sign = AESUtils.md5Encrypt(sha256Str).toUpperCase()
        return {
            "data": ase256.toString(),
            "sign": sign
        };
    }
}